import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './FormMobil.css';

const AdminTambahMobil = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    merk: 'Toyota',
    model: '',
    tahun: new Date().getFullYear(),
    kilometer: 0,
    warna: [],
    transmisiHarga: [],
    bahanBakar: 'Bensin',
    kondisi: 'Baru',
    jenis: '',
    deskripsi: '',
    gambar: [],
    stok: ''
  });
  const [warnaInput, setWarnaInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [tipeHargaList, setTipeHargaList] = useState([{ tipe: '', harga: '' }]);

  useEffect(() => {
    const isAdmin = localStorage.getItem('adminLoggedIn') === 'true';
    if (!isAdmin) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleWarnaAdd = () => {
    if (warnaInput.trim()) {
      setFormData({
        ...formData,
        warna: [...formData.warna, warnaInput.trim()]
      });
      setWarnaInput('');
    }
  };

  const handleWarnaRemove = (index) => {
    setFormData({
      ...formData,
      warna: formData.warna.filter((_, i) => i !== index)
    });
  };

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length + selectedImages.length > 10) {
      alert('Maksimal 10 gambar');
      return;
    }

    // Validasi hanya JPEG
    const invalidFiles = files.filter(file => {
      const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg';
      return !isJpeg;
    });

    if (invalidFiles.length > 0) {
      alert('Hanya file JPEG/JPG yang diperbolehkan');
      return;
    }

    setSelectedImages([...selectedImages, ...files]);
  };

  const handleImageRemove = (index) => {
    setSelectedImages(selectedImages.filter((_, i) => i !== index));
  };

  const handleImageUpload = async () => {
    if (selectedImages.length === 0) return;

    setUploading(true);
    try {
      const formDataUpload = new FormData();
      selectedImages.forEach((file) => {
        formDataUpload.append('images', file);
      });

      const response = await axios.post('/api/mobil/upload', formDataUpload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setFormData(prev => ({
        ...prev,
        gambar: [...prev.gambar, ...response.data.images]
      }));
      setSelectedImages([]);
      setUploading(false);
      alert('Gambar berhasil diupload');
    } catch (error) {
      console.error('Error uploading images:', error);
      alert('Gagal upload gambar: ' + (error.response?.data?.message || error.message));
      setUploading(false);
    }
  };

  const handleGambarRemove = (index) => {
    setFormData(prev => ({
      ...prev,
      gambar: prev.gambar.filter((_, i) => i !== index)
    }));
  };

  const handleTipeHargaAdd = () => {
    setTipeHargaList([...tipeHargaList, { tipe: '', harga: '' }]);
  };

  const handleTipeHargaRemove = (index) => {
    if (tipeHargaList.length > 1) {
      setTipeHargaList(tipeHargaList.filter((_, i) => i !== index));
    }
  };

  const handleTipeHargaChange = (index, field, value) => {
    const updated = [...tipeHargaList];
    updated[index][field] = value;
    setTipeHargaList(updated);
  };

  useEffect(() => {
    const transmisiHarga = tipeHargaList
      .filter(item => item.tipe.trim() !== '' && item.harga.trim() !== '')
      .map(item => ({
        type: item.tipe.trim(),
        harga: parseInt(item.harga) || 0
      }))
      .filter(item => item.harga > 0);
    
    setFormData(prev => ({
      ...prev,
      transmisiHarga: transmisiHarga
    }));
  }, [tipeHargaList]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.transmisiHarga.length === 0) {
      alert('Masukkan minimal satu tipe dengan harga');
      return;
    }

    if (formData.gambar.length === 0) {
      alert('Upload minimal satu gambar');
      return;
    }

    setLoading(true);

    try {
      const dataToSend = {
        ...formData,
        tahun: parseInt(formData.tahun),
        kilometer: parseInt(formData.kilometer),
        stok: parseInt(formData.stok)
      };

      const response = await axios.post('/api/mobil', dataToSend);
      
      // Pastikan data berhasil disimpan
      if (response.status === 201) {
        // Set flag untuk refresh
        sessionStorage.setItem('mobilNeedsRefresh', 'true');
        // Trigger refresh di halaman admin mobil
        window.dispatchEvent(new Event('mobilUpdated'));
        // Navigate setelah data tersimpan dengan delay kecil
        setTimeout(() => {
          navigate('/admin/mobil');
        }, 100);
      }
    } catch (error) {
      console.error('Error adding mobil:', error);
      alert('Gagal menambah mobil');
      setLoading(false);
    }
  };

  return (
    <div className="form-mobil">
      <div className="container">
        <h1 className="page-title">Tambah Mobil Toyota Baru</h1>

        <form onSubmit={handleSubmit} className="mobil-form">
          <div className="form-grid">
            <div className="input-group">
              <label>Model *</label>
              <input
                type="text"
                name="model"
                value={formData.model}
                onChange={handleChange}
                required
                placeholder="Contoh: All New Avanza"
              />
            </div>

            <div className="input-group">
              <label>Jenis Mobil *</label>
              <select
                name="jenis"
                value={formData.jenis}
                onChange={handleChange}
                required
              >
                <option value="">Pilih Jenis</option>
                <option value="SUV">SUV</option>
                <option value="Sedan">Sedan</option>
                <option value="Hatchback">Hatchback</option>
                <option value="MPV">MPV</option>
                <option value="Commercial">Commercial</option>
                <option value="Sport">Sport</option>
              </select>
            </div>

            <div className="input-group">
              <label>Tahun *</label>
              <input
                type="number"
                name="tahun"
                value={formData.tahun}
                onChange={handleChange}
                required
                min="2020"
                max="2025"
              />
            </div>

            <div className="input-group">
              <label>Kilometer *</label>
              <input
                type="number"
                name="kilometer"
                value={formData.kilometer}
                onChange={handleChange}
                required
                min="0"
              />
            </div>

            <div className="input-group">
              <label>Bahan Bakar *</label>
              <select
                name="bahanBakar"
                value={formData.bahanBakar}
                onChange={handleChange}
                required
              >
                <option value="Bensin">Bensin</option>
                <option value="Diesel">Diesel</option>
                <option value="Listrik">Listrik</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>

            <div className="input-group">
              <label>Stok *</label>
              <input
                type="number"
                name="stok"
                value={formData.stok}
                onChange={handleChange}
                required
                min="0"
                placeholder="5"
              />
            </div>
          </div>

          {/* Tipe & Harga */}
          <div className="input-group tipe-harga-section">
            <label>Tipe & Harga *</label>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
              Masukkan deskripsi tipe dan harga untuk setiap varian mobil
            </p>
            {tipeHargaList.map((item, index) => (
              <div key={index} className="tipe-harga-item" style={{ 
                display: 'flex', 
                gap: '15px', 
                marginBottom: '15px',
                alignItems: 'flex-end'
              }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '600' }}>
                    Deskripsi Tipe
                  </label>
                  <input
                    type="text"
                    value={item.tipe}
                    onChange={(e) => handleTipeHargaChange(index, 'tipe', e.target.value)}
                    placeholder="Contoh: All New Avanza 1.3 G M/T"
                    className="form-control"
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '600' }}>
                    Harga (Rp)
                  </label>
                  <input
                    type="number"
                    value={item.harga}
                    onChange={(e) => handleTipeHargaChange(index, 'harga', e.target.value)}
                    placeholder="Contoh: 200000000"
                    className="form-control"
                    required
                    min="0"
                  />
                </div>
                {tipeHargaList.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleTipeHargaRemove(index)}
                    className="btn btn-danger"
                    style={{ padding: '10px 15px', minWidth: 'auto' }}
                  >
                    Hapus
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              onClick={handleTipeHargaAdd}
              className="btn btn-secondary"
              style={{ marginTop: '10px' }}
            >
              + Tambah Tipe & Harga
            </button>
          </div>

          {/* Upload Gambar */}
          <div className="input-group">
            <label>Upload Gambar (JPEG, Maks 10) *</label>
            <div className="upload-section">
              <input
                type="file"
                accept="image/jpeg,image/jpg"
                multiple
                onChange={handleImageSelect}
                className="file-input"
                disabled={formData.gambar.length >= 10}
              />
              <p className="upload-info">
                {formData.gambar.length}/10 gambar terupload. 
                {selectedImages.length > 0 && ` ${selectedImages.length} gambar dipilih.`}
              </p>
              
              {selectedImages.length > 0 && (
                <div className="selected-images-preview">
                  <p>Gambar yang dipilih:</p>
                  <div className="image-preview-list">
                    {selectedImages.map((file, index) => (
                      <div key={index} className="image-preview-item">
                        <img src={URL.createObjectURL(file)} alt={`Preview ${index + 1}`} />
                        <button
                          type="button"
                          onClick={() => handleImageRemove(index)}
                          className="remove-image-btn"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={handleImageUpload}
                    className="btn btn-primary"
                    disabled={uploading}
                  >
                    {uploading ? 'Uploading...' : 'Upload Gambar'}
                  </button>
                </div>
              )}

              {formData.gambar.length > 0 && (
                <div className="uploaded-images">
                  <p>Gambar yang sudah diupload:</p>
                  <div className="image-preview-list">
                    {formData.gambar.map((url, index) => (
                      <div key={index} className="image-preview-item">
                        <img src={url} alt={`Uploaded ${index + 1}`} />
                        <button
                          type="button"
                          onClick={() => handleGambarRemove(index)}
                          className="remove-image-btn"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Warna */}
          <div className="input-group">
            <label>Warna Tersedia *</label>
            <div className="warna-input-group">
              <input
                type="text"
                value={warnaInput}
                onChange={(e) => setWarnaInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleWarnaAdd())}
                placeholder="Masukkan warna, lalu tekan Enter"
                className="warna-input"
              />
              <button type="button" onClick={handleWarnaAdd} className="btn btn-secondary">
                Tambah
              </button>
            </div>
            <div className="warna-list">
              {formData.warna.map((w, index) => (
                <span key={index} className="warna-tag">
                  {w}
                  <button type="button" onClick={() => handleWarnaRemove(index)} className="warna-remove">×</button>
                </span>
              ))}
            </div>
          </div>

          {/* Deskripsi */}
          <div className="input-group">
            <label>Deskripsi *</label>
            <textarea
              name="deskripsi"
              value={formData.deskripsi}
              onChange={handleChange}
              required
              placeholder="Deskripsi lengkap tentang mobil..."
              rows="5"
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading || uploading}>
              {loading ? 'Menyimpan...' : 'Tambah Mobil'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/admin/mobil')}
              className="btn btn-secondary"
            >
              Batal
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminTambahMobil;
